import React from 'react'
import { BankCardDisplayStyled } from './BankCardDisplay.styled'
import { makeAccessibleName } from './helpers'

type Props = {
  issuerName: string
  lastFour: string
}

export const BankCardDisplay = ({ issuerName, lastFour }: Props) => {
  return (
    <BankCardDisplayStyled aria-label={makeAccessibleName(issuerName, lastFour)}>
      <span>{issuerName}</span>
      <span>....</span>
      <span>{lastFour}</span>
    </BankCardDisplayStyled>
  )
}
